import { HttpInterceptorFn } from '@angular/common/http';
import { from, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Auth } from 'aws-amplify';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.includes(environment.AUTH_SERVICE_URL)) {
        return next(req);
    }

    return from(Auth.currentSession()).pipe(
        catchError(() => of(null)),
        switchMap((session) => {
            const token = session?.getAccessToken().getJwtToken();
            const authReq = req.clone({
                setHeaders: {
                    ['x-api-key']: environment.eplata_api_key_auth,
                    Authorization: `Bearer ${token}`
                },
            });
            return next(authReq);
        }),
    );
};